import { render } from "./VideoPlayer.vue?vue&type=template&id=e8b554fa&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=e8b554fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8b554fa"

export default script